import { nextIntersect } from "../../helpers"

class HighchartElement extends HTMLElement {
  async connectedCallback() {
    if (!this.hasAttribute("options")) return
    const options = this.getAttribute("options")
    this.removeAttribute("options")

    await nextIntersect(this)

    const { Highcharts } = await import("../highcharts")
    Highcharts.chart(this, JSON.parse(options))
  }
}

customElements.define("high-chart", HighchartElement)
